import React from 'react';
import { useNavigate } from 'react-router-dom';
import './usermenuoptions.scss';
import { useDispatch } from 'react-redux';
import { signout } from '../../actions';

function UserMenuOptions({ name, email }) {
  const displayLetter = name.trimLeft().slice(0, 1);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignout = () => {
    dispatch(signout());
    localStorage.clear();
    navigate('/');
  };

  return (
    <span className="avatar options user">
      {displayLetter}
      <div className="options-list menu-holder">
        <div className="menu menu-mod">
          <div className="menu-flex">
            <div
              className="avatar"
              style={{
                width: '70px',
                height: 'unset',
                aspectRatio: '1/1',
                fontSize: '40px',
                position: 'relative',
              }}>
              {displayLetter}
            </div>
          </div>
          <div className="name_holder">
            <p>{name}</p>
            <span>{email}</span>
          </div>
          {/* <button className="manage_account">Manage your account</button> */}

          <div className="menu-end">
            <button className="menu-button pop" onClick={handleSignout}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </span>
  );
}

export default UserMenuOptions;
